import { createSelector } from 'reselect';

import countriesSelector from './countriesSelector';

export default createSelector(countriesSelector, (countries) => countries.length > 0);
